var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6666 40V37.3333C38.6666 35.9188 38.1047 34.5623 37.1045 33.5621C36.1043 32.5619 34.7477 32 33.3333 32H22.6666C21.2521 32 19.8955 32.5619 18.8953 33.5621C17.8952 34.5623 17.3333 35.9188 17.3333 37.3333V40",
    stroke: "#77787B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 26.6667C30.9456 26.6667 33.3334 24.2789 33.3334 21.3333C33.3334 18.3878 30.9456 16 28.0001 16C25.0546 16 22.6667 18.3878 22.6667 21.3333C22.6667 24.2789 25.0546 26.6667 28.0001 26.6667Z",
    stroke: "#77787B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d4962a2586fbb442503145005781260f.svg";
export { ForwardRef as ReactComponent };